import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const STATUS_STYLES = {
  published: "bg-[#e6f4ea] text-[#1e7e34]",
  draft: "bg-[#f4f4f4] text-[#555555]",
  scheduled: "bg-[#fff4e5] text-[#b25e09]",
};

const AdminBlogListPage = () => {
  const [posts, setPosts] = useState(null);

  const load = () =>
    axios.get(`${API}/admin/blog`, { withCredentials: true }).then((res) => setPosts(res.data));

  useEffect(() => {
    load();
  }, []);

  async function toggleStatus(post) {
    const next = post.status === "published" ? "draft" : "published";
    await axios.put(
      `${API}/admin/blog/${post.id}`,
      { ...post, status: next },
      { withCredentials: true }
    );
    load();
  }

  async function remove(post) {
    if (!window.confirm(`Delete "${post.title}"? This cannot be undone.`)) return;
    await axios.delete(`${API}/admin/blog/${post.id}`, { withCredentials: true });
    load();
  }

  return (
    <div data-testid="admin-blog-list">
      <div className="flex items-center justify-between mb-8">
        <h1 className="font-disp text-3xl text-[#121212]">Blog Posts</h1>
        <Link
          to="/admin/blog/new"
          data-testid="admin-blog-new-button"
          className="px-5 py-3 bg-[#121212] text-white text-xs font-mono uppercase tracking-[.14em] hover:bg-[#e02020] transition-colors rounded-none"
        >
          New Post
        </Link>
      </div>

      {posts === null ? (
        <p className="text-xs font-mono uppercase tracking-[.14em] text-[#555555]">Loading…</p>
      ) : posts.length === 0 ? (
        <div className="bg-white border border-[#e5e5e5] p-10 text-center">
          <p className="text-sm text-[#555555] mb-4">
            No posts yet. Publish the first essay when you are ready.
          </p>
          <Link
            to="/admin/blog/new"
            className="text-xs font-mono uppercase tracking-[.14em] text-[#121212] underline underline-offset-4 hover:text-[#e02020]"
          >
            Create a Post →
          </Link>
        </div>
      ) : (
        <div className="bg-white border border-[#e5e5e5] divide-y divide-[#e5e5e5]">
          {posts.map((post) => (
            <div
              key={post.id}
              data-testid={`admin-post-row-${post.id}`}
              className="p-5 flex flex-col md:flex-row md:items-center gap-4 justify-between"
            >
              <div className="min-w-0">
                <p className="font-disp text-lg text-[#121212] truncate">{post.title}</p>
                <p className="text-xs font-mono text-[#6b6b6b]">
                  /blog/{post.slug} · {post.category}
                </p>
              </div>
              <div className="flex items-center gap-4 shrink-0">
                <span
                  className={`text-xs font-mono uppercase tracking-[.14em] px-2 py-1 ${STATUS_STYLES[post.status] || STATUS_STYLES.draft}`}
                >
                  {post.status}
                </span>
                <button
                  type="button"
                  onClick={() => toggleStatus(post)}
                  data-testid={`admin-post-toggle-${post.id}`}
                  className="text-xs font-mono uppercase tracking-[.14em] text-[#121212] underline underline-offset-4 hover:text-[#e02020]"
                >
                  {post.status === "published" ? "Unpublish" : "Publish"}
                </button>
                <Link
                  to={`/admin/blog/${post.id}/edit`}
                  data-testid={`admin-post-edit-${post.id}`}
                  className="text-xs font-mono uppercase tracking-[.14em] text-[#121212] underline underline-offset-4 hover:text-[#e02020]"
                >
                  Edit
                </Link>
                <button
                  type="button"
                  onClick={() => remove(post)}
                  data-testid={`admin-post-delete-${post.id}`}
                  className="text-xs font-mono uppercase tracking-[.14em] text-[#6b6b6b] hover:text-[#e02020]"
                >
                  Delete
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default AdminBlogListPage;
